// extracted by mini-css-extract-plugin
export default {"join":"JoinSection_join__GhkGQ","h2":"JoinSection_h2__36W7k","btns":"JoinSection_btns__qr3tb"};